import { darken } from '@material-ui/core';
import defaultPalette from '../palette';
export default (function (_a) {
    var _b, _c, _d;
    var _e = _a.palette, palette = _e === void 0 ? defaultPalette : _e;
    var PRIMARY_DARK_HOVER = darken((_b = palette === null || palette === void 0 ? void 0 : palette.primary) === null || _b === void 0 ? void 0 : _b.dark, 0.3);
    return {
        MuiPagination: {
            root: {
                '& button.Mui-selected': {
                    backgroundColor: (_c = palette === null || palette === void 0 ? void 0 : palette.primary) === null || _c === void 0 ? void 0 : _c.dark,
                    color: (_d = palette === null || palette === void 0 ? void 0 : palette.primary) === null || _d === void 0 ? void 0 : _d.contrastText,
                },
                '& button.Mui-selected:hover': {
                    backgroundColor: PRIMARY_DARK_HOVER,
                },
            },
        },
    };
});
